import { render, staticRenderFns } from "./user-roles-member.vue?vue&type=template&id=32c2ded7&"
import script from "./user-roles-member.vue?vue&type=script&lang=js&"
export * from "./user-roles-member.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports